import { useMemo } from "react";
import styled from "styled-components";
import { SP_BREAKPOINT } from "../../../constants/app";
import { PRIMARY_LIGHT_GREEN } from "../../../constants/color";
import { TableHeaderItem } from "../../../hooks/useTable";
import { Button } from "../../atoms/Button";
import { TableTemplate } from "../../templates/TableTemplate";
import { FileUploading } from "./FileUploading";

type Props = {
  fileName: string;
  fileSize: string;
  templateName: string;
  isUploading: boolean;
  onCancel: () => void;
  onUpload: () => void;
};

export const FileResult: React.FC<Props> = ({
  fileName,
  fileSize,
  templateName,
  isUploading,
  onCancel,
  onUpload,
}) => {
  const tableHeaders: TableHeaderItem<{}>[] = useMemo(() => {
    return [
      { id: 1, title: "ファイル名", dataKey: "fileName" },
      { id: 2, title: "サイズ", dataKey: "fileSize" },
      { id: 3, title: "テンプレート", dataKey: "templateName" },
      {
        id: 4,
        title: "ステータス",
        dataKey: "result",
        customComponent: isUploading ? FileUploading : undefined,
      },
    ];
  }, [isUploading]);

  const fileData = useMemo(() => {
    return {
      fileName,
      fileSize,
      templateName,
      result: isUploading ? "転送中" : "アップロード可能",
    };
  }, [fileName, fileSize, templateName, isUploading]);

  return (
    <StyledBackground>
      <StyledFileUploadContainer>
        <StyledTitle>アップロードファイル</StyledTitle>

        <StyledFileUploadResult>
          <TableTemplate
            headers={tableHeaders}
            data={[fileData]}
            fetchDataFunction={() => {}}
          />
        </StyledFileUploadResult>
      </StyledFileUploadContainer>

      <StyledFooter>
        <Button text="キャンセル" variant="dark" onClick={onCancel} />
        <Button
          text="アップロード"
          variant="filled"
          onClick={onUpload}
          disabled={templateName === ""}
        />
      </StyledFooter>
    </StyledBackground>
  );
};

const StyledBackground = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    display: none;
  }

  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 4px;
  background: ${PRIMARY_LIGHT_GREEN};
`;

const StyledFileUploadContainer = styled.div`
  display: flex;
  padding: 12px 20px 16px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
  border-radius: 4px;
  background: #ffffff;
`;

const StyledTitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 200%;
`;

const StyledFileUploadResult = styled.div`
  flex-shrink: 0;
  align-self: stretch;

  tr {
    border: none;
  }

  td {
    padding: 8px 16px;
  }
`;

const StyledFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;
